import { useGoodsRoute } from '../../../hooks/useGoodsRoute';
import { useMemo } from 'react';

export const useFixedCouponSno = (): number | undefined => {
  const { params } = useGoodsRoute<'GoodsDetail'>();

  return useMemo(() => {
    return params.extras?.coupon_sno;
  }, [params.extras]);
};
